// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"e0oojjTbGH0nyQwYaHMcK"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from "@sentry/nextjs";
import { SENTRY_DSN, SENTRY_ENVIRONMENT } from "@/lib/constants";
import Logger from '@/lib/logger';

const logger = new Logger('sentry.client.config');

const defaultInit = {
  dsn: SENTRY_DSN,
  sampleRate: 0.0,
  tracesSampleRate: 0,
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 0.0,
  debug: false,
};

const initObj = { environment: "", integrations: [] as any[], ...defaultInit };

switch (SENTRY_ENVIRONMENT) {
  case "edcar":
    logger.info("Enabling Sentry for edcar...");
    initObj.sampleRate = 0.5;
    initObj.tracesSampleRate = 0.5;
    initObj.replaysSessionSampleRate = 0.5;
    initObj.replaysOnErrorSampleRate = 1.0;
    initObj.environment = "edcar"
    break;
  case "staging":
    // TODO
    initObj.environment = "staging"
    break;
  case "production":
    logger.info("Enabling Sentry for production...");
    initObj.integrations = [ Sentry.replayIntegration() ];
    initObj.sampleRate= 0.25;
    initObj.tracesSampleRate= 1;
    initObj.replaysSessionSampleRate= 0.2;
    initObj.replaysOnErrorSampleRate= 1.0;
    initObj.environment = "production"
    break;
  default:
    // Default case for "development" environment
    initObj.environment = "development"
    break;
}

Sentry.init(initObj);
